<template>
  <div>
    <span v-if="error" class="help is-danger">
      {{error}}
      <div class="reload">
        <button class="button" v-on:click="reload()">Reload</button>
      </div>
    </span>
    <div class="loadWrapper" v-if="!error && (loading || pageLoading)">
      <loading
        :text="'Loading ' + (loading || bookUtils.isPDF(book) ? 'book' : 'page') + '. Please wait...'"
        :zIndex="999"
        :color="'white'"
        style="top: 30%; color: white"
      />
    </div>
    <div v-if="(!error && book) || (!pageLoading)" class="book-view-container">
      <div class="toc-view" :style="{width: tocOpen ? '350px' : '0'}" style="position: fixed; top: 66px; z-index: 601">
        <Toc
          v-if="metadata"
          v-show="tocOpen"
          :bookmarks="metadata.bookmarks"
          :title="book.title"
          v-bind="{currentPage, onCurrentPageChanged, toggleTOC}"
        ></Toc>
      </div>
      <div
        class="book-view"
        :style="{'max-width': 'calc(100vw - ' + (resourcePanelOpen ? 250 : 6) + 'px)'}"
      >
        <!-- <h1>{{book.title}}</h1> -->
        <!-- TOP TOOLBAR -->
        <span v-if="!pageLoading">
          <div v-if="!hideToolsOnFlashcardEditor" class="tools no-select" style="z-index: 599 !important">
            <slot v-if="hlPenMode.length > 0 && !showSearchMode">
              <div class="tool">
                <div class="icon-button" @click="hlPenMode='';textToSpeech=false;stopSpeechSynth()" title="Back">
                  <i class="fal fa-arrow-left"></i>
                </div>
              </div>
              <div class="tool-style-picker" v-if="!textToSpeech">
                <HLPenStylePicker
                  :settings="hlPenSettings"
                  :mode="hlPenMode"
                  @colorChange="setHLPenColor"
                  @lineChange="setHLPenThickness"
                />
              </div>
              <div class="tool" v-if="!textToSpeech">
                <div v-if="bookUtils.isMPUB(book)"
                  :class="{disabled: !undoEnabled}"
                  @click="undo();"
                  title="Undo"
                  class="icon-button"
                >
                  <i class="fal fa-undo-alt"></i>
                </div>
                <div v-else
                  :class="{disabled: true}"
                  title="Undo - Coming Soon"
                  class="icon-button"
                >
                  <i class="fal fa-undo-alt"></i>
                </div>
              </div>
              <div v-if="hlPenMode === 'pen'" class="tool">
                <div
                  :class="{disabled: !redoEnabled}"
                  title="Redo - Coming Soon"
                  class="icon-button"
                >
                  <i class="fal fa-redo-alt"></i>
                </div>
              </div>
              <div v-if="hlPenMode === 'textToSpeech'" class="tool">
                <div class="tool">
                  <select class="form-control icon-button dropdownMenuNumber" id="voices" v-model="selectedVoice" title="Select a voice">
                    <option v-for="(voice, index) in voiceList" :data-lang="voice.lang" :value="index" :key="index">
                      {{ voice.name }} ({{ voice.lang }})
                    </option>
                  </select>
                </div>
                <slot v-if="bookUtils.isMPUB(book)">
                  <div
                    :class="{disabled: textToSpeechPlaying ? false : true}"
                    title="Cancel"
                    class="tool"
                    @click="stopSpeechSynth()"
                  >
                    <div class="icon-button">
                      <i class="fal fa-stop"></i>
                    </div>
                  </div>
                  <div
                    :class="{disabled: textToSpeechPlaying ? false : true}"
                    :title="!textToSpeechPaused ? 'Pause' : 'Play'"
                    @click="!textToSpeechPaused ? pauseSpeechSynth() : resumeSpeechSynth()"
                    class="tool"
                  >
                    <div class="icon-button">
                      <i v-if="!textToSpeechPaused" class="fal fa-pause"></i>
                      <i v-else class="fal fa-play"></i>
                    </div>
                  </div>
                </slot>
                <slot v-else-if="bookUtils.isPDF(book)">
                  <div
                    title="Cancel"
                    class="tool"
                    @click="stopSpeechSynthPDF()"
                  >
                    <div class="icon-button">
                      <i class="fal fa-stop"></i>
                    </div>
                  </div>
                  <div
                    :title="!TTSPaused ? 'Pause' : 'Play'"
                    @click="!TTSPaused ? pauseSpeechSynthPDF() : resumeSpeechSynthPDF()"
                    class="tool"
                  >
                    <div class="icon-button">
                      <i v-if="!TTSPaused" class="fal fa-pause"></i>
                      <i v-else class="fal fa-play"></i>
                    </div>
                  </div>
                </slot>
                <div class="tool"><div class="tool">
                      <i v-if="textToSpeechRate < 10" class="fal fa-tachometer-slowest ttsIcons"></i>
                      <i v-if="textToSpeechRate >= 10 && textToSpeechRate < 15" class="fal fa-tachometer-slow ttsIcons"></i>
                      <i v-if="textToSpeechRate >= 15 && textToSpeechRate <= 30" class="fal fa-tachometer-average ttsIcons"></i>
                      <i v-if="textToSpeechRate > 30 && textToSpeechRate < 50" class="fal fa-tachometer-fast ttsIcons"></i>
                      <i v-if="textToSpeechRate == 50" class="fal fa-tachometer-fastest ttsIcons"></i>
                    </div>
                  <div class="tool">
                    
                    <input type="range" min="0" max="50" v-model="textToSpeechRate" class="icon-button" style="margin-left: 5px !important">
                  </div><div class="tool">
                      <i v-if="textToSpeechVolume <= 0" class="fal fa-volume-off ttsIcons"></i>
                      <i v-if="textToSpeechVolume > 0 && textToSpeechVolume <= 2" class="fal fa-volume-down ttsIcons"></i>
                      <i v-if="textToSpeechVolume > 2 && textToSpeechVolume <= 7" class="fal fa-volume ttsIcons"></i>
                      <i v-if="textToSpeechVolume > 7" class="fal fa-volume-up ttsIcons"></i>
                    </div>
                  <div class="tool">
                    
                    <input type="range" min="0" max="10" v-model="textToSpeechVolume" class="icon-button" style="margin-left: 5px !important">
                  </div>
                </div>
              </div>
              
              <div class="tool" style="width: 100%" />
            </slot>
            <slot v-if="hlPenMode.length === 0 && !showSearchMode && !pageLoading && !textToSpeech">
              <div v-if="!tocOpen" class="tool">
                <div class="icon-button" @click="toggleTOC()" title="Toggle TOC">
                  <i class="fal fa-bars"></i>
                </div>
              </div>
              <div class="tool">
                <div class="icon-button" @click="highlighterMode()" title="Highlighter Mode">
                  <i class="fal fa-highlighter"></i>
                </div>
              </div>
              <div class="tool" v-if="bookUtils.isMPUB(book)">
                <div class="icon-button" @click="editorToView = !editorToView" title="Font Color Mode">
                  <i class="fal fa-palette"></i>
                </div>
              </div>
              <div class="tool">
                <div class="icon-button" @click="toggleTextToSpeech()" title="Text to speech">
                  <i class="fal fa-comment"></i>
                </div>
              </div>
              <div class="tool" v-if="bookUtils.isPDF(book)">
                <div class="icon-button" @click="penMode()" title="Draw Mode">
                  <i class="fal fa-pen"></i>
                </div>
              </div>
              <div class="tool">
                <div class="icon-button" @click="eyeMode()" title="Toggle Annotations">
                  <i
                    class="fal"
                    :class="{'fa-eye-slash': !showAnnotations, 'fa-eye': showAnnotations}"
                  ></i>
                </div>
              </div>
              <div class="tool">
                <div class="icon-button" @click="flashcardEditor()" title="Flashcard Decks">
                  <i class="fal fa-clone"></i>
                </div>
              </div>
              <div class="tool" style="width: 100%" />
              <div class="tool">
                <div class="icon-button" @click="saveAnnotations()" title="Save annotations">
                  <i v-if="saving == true && savingSuccess == false" class="fal fa-spinner fa-pulse"></i>
                  <i v-else-if="saving == true && savingSuccess == true" class="fal fa-check" style="color: green"></i>
                  <i v-else class="fal fa-save"></i>
                </div>
              </div>
              <div class="tool">
                <div class="icon-button" @click="toggleSearchMode()" title="Search">
                  <i class="fal fa-search"></i>
                </div>
              </div>
              <div class="tool">
                <Popover placement="bottom" :width="230">
                  <div class="icon-button more-options" title="More options">
                    <i class="fal fa-ellipsis-v"></i>
                  </div>
                  <div slot="content">
                    <div class="list-item" v-on:click.stop="generateSummaryForPages()">
                      <span class="popover-list-image">
                        <i class="fal fa-list"></i>
                      </span>
                      <span class="action-item">Generate Summary</span>
                    </div>
                    <div class="list-item" v-on:click.stop="fullscreenMode()">
                      <slot v-if="fullscreen">
                        <span class="popover-list-image">
                          <i class="fal fa-compress"></i>
                        </span>
                        <span class="action-item">Exit Fullscreen</span>
                      </slot>
                      <slot v-else>
                        <span class="popover-list-image">
                          <i class="fal fa-expand"></i>
                        </span>
                        <span class="action-item">Enter Fullscreen</span>
                      </slot>
                    </div>
                  </div>
                </Popover>
              </div>
              <div class="tool disabled">
                <!-- <div class="icon-button" @click="zoomOut()" title="Zoom Out"> -->
                <div class="icon-button" title="Zoom Out - Coming soon">
                  <i class="fal fa-minus"></i>
                </div>
              </div>
              <div class="tool disabled">
                <span class="zoom-label">{{scale}}%</span>
              </div>
              <div class="tool disabled">
                <!-- <div class="icon-button" @click="zoomIn()" title="Zoom In"> -->
                <div class="icon-button" title="Zoom In - Coming soon">
                  <i class="fal fa-plus"></i>
                </div>
              </div>
              <div v-if="!resourcePanelOpen" class="tool">
                <div class="icon-button" @click="toggleResources()" title="Toggle Resources">
                  <i class="fal fa-paperclip"></i>
                </div>
              </div>
            </slot>
            <div v-if="showSearchMode" class="search-mode">
              <div class="search-table">
                <div class="search-row">
                  <div class="search-bar">
                    <Search
                      v-on:searcher="onSearch"
                      v-on:clicked="toggleSearchResults"
                      :searchValue="search"
                      :placeholder="'Search'"
                      class="search"
                    />
                  </div>
                  <div class="search-close">
                    <span @click="toggleSearchMode()" class="close-search icon-button">Cancel</span>
                  </div>
                </div>
              </div>
              <popover placement="bottom" :width="450">
                <button class="search-button"></button>
                <div slot="content" class="searched-content">
                  <slot v-if="searchResults.length > 0 || search.length > 1">
                    <div class="search-header">
                      <span v-if="searchResults.length > 1"><span v-if="searchResults.length === 200">+</span>{{searchResults.length}} results</span>
                      <span v-else-if="searchResults.length < 1">0 results</span>
                      <span v-else>1 result</span>
                    </div>
                    <div class="search-results">
                      <slot v-if="searchResults.length > 0 && !searchLoading && bookUtils.isPDF(book)"> <!--PDF-->
                        <div
                          v-for="(result, i) in searchResults"
                          :key="i"
                          @click="onCurrentPageChanged(Math.min(pageCount, result.page), 'search'); "
                          class="tr"
                        >
                          <span v-html="boldString(utils.truncateString(result.text, 55), search)" class="result"></span>
                          <span class="on-page">{{result.page}}</span>
                        </div>
                      </slot>

                      <slot v-else-if="searchResults.length > 0 && !searchLoading && bookUtils.isMPUB(book)"> <!--EPUB-->
                        <div
                          v-for="(result, i) in searchResults"
                          :key="i"
                          @click="setSearchIndex(result.index); onCurrentPageChanged(Math.min(pageCount, result.pageRange[0]), 'search');"
                          class="tr"
                        >
                          <span v-html="boldString(utils.epubSearchTruncateString(result.context, 50), search)" class="result"></span>
                          <span class="on-page" v-html="result.pageRange[0] + ' - ' + result.pageRange[1]"></span>
                        </div>
                      </slot>

                      <slot v-else>
                        <slot v-if="searchLoading">
                          <loading text="Searching..." />
                        </slot>
                        <slot v-else>
                          <span class="no-search-results">No search results found.</span>
                        </slot>
                      </slot>
                    </div>
                  </slot>
                  <slot v-else>
                    <div class="search-header">
                      <span>Recent Searches</span>
                    </div>
                    <div class="search-results">
                      <div
                        v-for="(result, i) in historySearchedResults[book.id]"
                        :key="i"
                        @click="onSearch(result.searchTerm)"
                        class="tr"
                      >
                        <span v-html="result.searchTerm" class="result"></span>
                        <span v-if="result.searchResults > 1" class="on-page"><span v-if="result.searchResults == 200">+</span>{{result.searchResults}} results</span>
                        <span v-else-if="result.searchResults < 1" class="on-page">0 results</span>
                        <span v-else class="on-page">1 result</span>
                      </div>
                    </div>
                  </slot>
                </div>
              </popover>
            </div>
          </div>
        </span>

        <!-- BOOKVIEW -->
        <div v-if="metadata">
          <PDFViewer2
            v-if="bookUtils.isPDF(book) && highlights"
            class="pdf-viewer"
            v-bind="{
              book,
              drawings,
              currentPage,
              onCurrentPageChanged,
              onCurrentScaleChanged,
              metadata,
              scaleZoom,
              isPDFPreviewEnabled,
              onPageLoading,
              resourcePanelOpen,
              tocOpen,
              flashcardDeckEditor,
              highlights,
              showAnnotations,
              contextMenuListItemOpen,
              hlPenMode,
              hlPenSettings,
              search,
              showSearchMode,
              undoCalled,
              redoCalled,
              selectedVoice,
              voiceList,
              textToSpeechRate,
              textToSpeechVolume,
              TTSPlaying,
              TTSPaused
            }"
            @toggleContextMenu="toggleContextMenu"
            @contextMenuSelector="val => contextMenuOptions.selector = val"
            @updateUndo="val => undoEnabled = val"
            @updateRedo="val => redoEnabled = val"
            @searchResults="(val) => {saveSearchResults(val); searchLoading = false}"
            @searchFound="val => {searchPopupOpen(); searchResults = val; searchLoading = false}"
            @flashcardOnSelect="setFlashcardEditorSelectText"
            @textToSpeech="setTextToSpeechPlaying"
            @TTSPlaying="setTTSPlaying"
            @TTSPaused="setTTSPaused"
            ref="epubOrPdfBookView"
          />

          <EpubViewer
            v-if="bookUtils.isMPUB(book) && highlights"
            v-bind="{
              book,
              activePages,
              currentPage,
              onCurrentPageChanged,
              metadata,
              scale,
              onPageLoading,
              tocOpen,
              flashcardDeckEditor,
              updatePrevChevron,
              updateNextChevron,
              highlights,
              showAnnotations,
              contextMenuListItemOpen,
              hlPenMode,
              hlPenSettings,
              currentPageDisplay,
              search,
              showSearchMode,
              searchIndex,
              greetingSpeech,
              selectedVoice,
              synth,
              voiceList,
              textToSpeechRate,
              textToSpeechVolume
            }"            
            @toggleContextMenu="toggleContextMenu"
            @contextMenuSelector="val => contextMenuOptions.selector = val"
            @updateUndo="val => undoEnabled = val"
            @flashcardOnSelect="setFlashcardEditorSelectText"
            @setPagePrev="val => epubPrevDoubleChevronActive = val"
            @setPageNext="val => epubNextDoubleChevronActive = val"
            @loadTime="calculateLoadTime"
            @searchResults="(val) => {saveSearchResults(val); searchLoading = false; searchResults = val}"
            @textToSpeech="setTextToSpeechPlaying"
            ref="epubOrPdfBookView"
          />

          <!-- MODALS -->
          <Note
            v-if="noteToView"
            @noteModalClosed="noteToView = undefined; contextMenuListItemOpen = false"
            v-bind="{contextMenuOptions}"
            :attachmentId="noteToView"
          />

          <Freehand
            v-if="freehandToView"
            @freehandModalClosed="freehandToView = undefined; contextMenuListItemOpen = false"
            v-bind="{contextMenuOptions}"
            :attachmentId="freehandToView"
          />

          <Editor
            v-if="editorToView"
            @editorModalClosed="editorToView = false"
            @setFontSize="setFontSize"
            @setFontColor="setFontColor"
            @setFontBackgroundColor="setFontBackgroundColor"
            @setFontStyle="setFontStyle"
            @setFontLineSpacing="setFontLineSpacing"
            @setFontLetterSpacing="setFontLetterSpacing"
          />

          <div v-if="showFlashcardDeckList && !showFlashcardDeckEditor">
            <FlashcardDeckList
              v-bind="{
                showFlashcardDeckList,
                currentPage,
                pageCount,
                book,
                flashcardDeckAttachmentsByResourceId,
                flashcardDecks,
                onCurrentPageChanged
              }"
              :bookMetadata="metadata"
              @openLocation="openLocation"
              @showFlashcardDeckEditorDefault="val => {resourcePanelOpen = false; tocOpen = false; flashcardDeckObject = undefined; flashcardDeckBeforeEditing = undefined; showFlashcardDeckEditor = val;}"
              @getFlashcardDeck="val => {resourcePanelOpen = false; tocOpen = false; flashcardDeckBeforeEditing = val; flashcardDeckObject = flashcardDeckBeforeEditing.flashcardDeckObject; showFlashcardDeckEditor = hideToolsOnFlashcardEditor = flashcardDeckEditor = true;}"
              @closeFlashcardDeckList="showFlashcardDeckList = false; contextMenuListItemOpen = false"
            />
          </div>
          <ContextMenu
            v-show="!flashcardDeckEditor && !showFlashcardDeckList && noteToView === undefined && freehandToView === undefined"
            @newFlashcardDeck="flashcardDeckObject = undefined; flashcardDeckBeforeEditing = undefined; showFlashcardDeckEditor = true; contextMenuListItemOpen = true; fromContextMenu = true"
            @newNote="noteToView = 'new'; contextMenuListItemOpen = true"
            @newFreehand="freehandToView = 'new'; contextMenuListItemOpen = true"
            v-bind="{location:'bookView'}"
          />
        </div>
      </div>

      <!-- RESOURCE PANEL -->
      <div
        :style="{width: resourcePanelOpen ? '250px' : '6px'}"
        class="resources-view"
        v-if="!pageLoading"
      >
        <ResourcePanelView
          v-bind="{
            resourcePanelOpen,
            attachments,
            resources,
            metadata, 
            currentPage,
            scale,
            toggleResources
          }"
          @viewNote="attachmentId => noteToView = attachmentId"
          @viewFreehand="attachmentId => freehandToView = attachmentId"
          :mpub="bookUtils.isMPUB(book)"
          :loaded="pageLoading"
          ref="resourcePanel"
        />
      </div>
    </div>

    <!-- FOOTER -->
    <div v-show="!pageLoading" class="footer-wrapper">
      <!-- BOTTOM NAVBAR -->
      <div
        class="no-select"
        v-bind:class="{'navigation':!flashcardDeckEditor, 'navigation-with-flashcard-editor':flashcardDeckEditor}"
        v-if="pageCount > 0"
      >
        <div v-if="!flashcardDeckEditor" class="slider">
          <SliderProgress
            :newValue="currentPage.oneBasedIndex"
            @slider-progress-update="val => onCurrentPageChanged(val, 'scrubber')"
            @slider-progress-display-update="onCurrentPageUsedForLabelChanged"
            :max="pageCount"
          />
        </div>
        <div class="tool">
          <div class="icon-button" @click="prevNav()" v-if="(currentPage.oneBasedIndex !== 1 || flashcardDeckEditor) && topScroll">
            <i class="fal" v-bind:class="{'fa-chevron-up': flashcardDeckEditor && !epubPrevDoubleChevronActive, 'fa-chevron-double-left': !flashcardDeckEditor && epubPrevDoubleChevronActive, 'fa-chevron-left': !flashcardDeckEditor && !epubPrevDoubleChevronActive, 'fa-chevron-double-up': epubPrevDoubleChevronActive && topScroll && flashcardDeckEditor}"></i>
          </div>
          <div class="icon-button-placeholder" v-else />
        </div>
        <div class="tool page-indicator">
          <slot v-if="!flashcardDeckEditor">
            <input :value="currentPageDisplay" @click="$event.target.select()" @change="onCurrentPageInput"/> / {{pageCount}}
          </slot>
        </div>
        <div class="tool">
          <div class="icon-button" @click="nextNav()" v-if="(currentPage.oneBasedIndex < pageCount || flashcardDeckEditor) && bottomScroll">
            <i class="fal" v-bind:class="{'fa-chevron-down': flashcardDeckEditor && !epubNextDoubleChevronActive, 'fa-chevron-double-right': !flashcardDeckEditor && epubNextDoubleChevronActive, 'fa-chevron-right': !flashcardDeckEditor &&! epubNextDoubleChevronActive, 'fa-chevron-double-down': epubNextDoubleChevronActive && bottomScroll && flashcardDeckEditor}"></i>
          </div>
          <div class="icon-button-placeholder" v-else />
        </div>
      </div>
      <!-- FLASHCARD EDITOR -->
      <div v-if="showFlashcardDeckEditor">
        <FlashcardEditor
          v-bind="{
            currentPage,
            pageCount,
            book,
            flashcardDeckObject,
            flashcardDecks,
            flashcardDeckBeforeEditing,
            modalView,
            flashcardEditorSelectText,
            fromContextMenu,
            contextMenuOptions,
            metadata
          }"
          @flashcardClose="showFlashcardDeckList = hideToolsOnFlashcardEditor = flashcardDeckEditor = showFlashcardDeckEditor = false; contextMenuListItemOpen = false"
          @returnToDeckList="showFlashcardDeckEditor = false; showFlashcardDeckList = fromContextMenu ? false : true; contextMenuListItemOpen = fromContextMenu ? false : true; fromContextMenu = false"
          @openFlashcardStyling="hideToolsOnFlashcardEditor = flashcardDeckEditor = true;"
          @flashcardOnSelect="val => flashcardEditorSelectText = val"
        ></FlashcardEditor>
      </div>
    </div>
  </div>
</template>

<script>
const _ = require("lodash");
const moment = require("moment");
require("moment-timezone");
moment.tz.setDefault("Africa/Johannesburg");

import Vue from "vue";
import utils from "@/utils/utils.js";
import bookUtils from "@/utils/bookUtils.js";
import storeHelpers from "@/utils/storeHelpers.js";
import epubUtils from "@/utils/epubUtils.js";
import analytics from "@/utils/analytics.js";
import Popover from "@/components/widgets/popover";
import PDFViewer2 from "./pdf/PDFViewer2";
import EpubViewer from "./epub/EpubViewer";
import SliderProgress from "@/components/widgets/SliderProgress";
import Toc from "./Toc";
import ResourcePanelView from "./ResourcePanelView";
import FlashcardEditor from "@/components/flashcards/FlashcardEditor";
import FlashcardDeckList from "@/components/flashcards/FlashcardDeckList";
import ContextMenu from "./annotations/ContextMenu";
import HLPenStylePicker from "./annotations/HLPenStylePicker";
import Freehand from "./annotations/Freehand";
import Note from "./annotations/Note";
import Editor from "./annotations/Editor";
import Search from "@/components/widgets/Search";

export default {
  name: "BookView",
  components: {
    Popover,
    PDFViewer2,
    EpubViewer,
    Toc,
    SliderProgress,
    FlashcardEditor,
    FlashcardDeckList,
    ResourcePanelView,
    ContextMenu,
    HLPenStylePicker,
    Note,
    Freehand,
    Search,
    Editor
  },
  beforeRouteEnter(to, from, next) {
    var loc = 0;
    switch (from.name) {
      case "MIEBOOKS_URL":
        loc = 2;
        break;
      case "Library":
        loc = 3;
        break;
      case "SUMMARY":
        loc = 5;
        break;
      case "BACK_FROM_RESOURCE":
        loc = 11;
        break;
      case "SummaryView":
        loc = 12;
        break;
      case "LearningPathFullscreen":
        loc = 16;
        break;
      case "default":
        loc = 0;
        break;
      default:
        loc = 1;
        break;
    }
    if (to.query.search) {
      loc = 15;
    }
    next(t => {
      t.location = loc;
    });
  },
  watch: {
    "$route.params.currentPage": {
      handler: function(currentPageDisplay) {
        this.onCurrentPageChanged(bookUtils.pageOneBasedIndex(this.metadata, currentPageDisplay, this.currentPage.method), "params");
        this.showFlashcardDeckList = false;
      },
      deep: true,
      immediate: true
    },
    searchLoading: {
      immediate: true,
      handler: function(searchLoading) {
        var t = this;
        // if (searchLoading) {
        //   setTimeout(() => {
        //     t.searchLoading = false;
        //   }, 5000);
        // }
      }
    },
    $route(to, from) {
      if (to.query.edit) {
        this.showFlashcardDeckList = false;
        this.resourcePanelOpen = false;
        this.tocOpen = false;
        var deckData = {};
        var flashcardId = to.query.edit;
        var t = this;
        utils.openFlashcardDeckById(this, flashcardId, function(res) {
          deckData.currentFlashcardDeckId = flashcardId;
          deckData.flashcardDeckObject = res.data;
          deckData.currentFlashcardDeckTitle = storeHelpers.getFlashcardDeckTitle(t, flashcardId);
          deckData.flashcardDeckEditor = true;
          t.flashcardDeckBeforeEditing = deckData;
          t.flashcardDeckObject =
            t.flashcardDeckBeforeEditing.flashcardDeckObject;
          t.showFlashcardDeckEditor = true;
          t.hideToolsOnFlashcardEditor = true;
          t.flashcardDeckEditor = true;
          var newRouteQuery = _.omit(t.$route.query, ["edit"]);
          t.$router.replace({ query: newRouteQuery });
        });
      }
      if (to.query.delete) {
        this.showFlashcardDeckList = false;
        this.hideToolsOnFlashcardEditor = false;
        this.flashcardDeckEditor = false;
        this.showFlashcardDeckEditor = false;
      }
    }
  },
  data() {
    return {
      saving: false,
      savingSuccess: false,
      moment: moment,
      utils: utils,
      bookUtils: bookUtils,
      unwatchFunctions: [],
      book: undefined,
      error: "",
      currentPage: { oneBasedIndex: 1, method: "init" },
      activePages: [],
      currentPageUsedForLabel: 1,
      pageCount: 0,
      loading: true,
      pageLoading: true,
      metadata: undefined,
      scale: 100,
      scaleZoom: 0,
      tocOpen: false,
      resourcePanelOpen: false,
      isPDFPreviewEnabled: true,
      showFlashcardDeckList: false,
      showFlashcardDeckEditor: false,
      hideToolsOnFlashcardEditor: false,
      hlPenMode: "",
      attachments: [],
      drawings: [],
      resources: [],
      flashcardDeckAttachmentsByResourceId: {},
      flashcardDecks: [],
      flashcardDeckEditor: false,
      contextMenuOptions: {
        bookId: "",
        selector: ""
      },
      selector: "",
      flashcardDeckObject: {
        flashCards: [{ _id: "flashCard-" + utils.GUID(), front: "", back: "" }]
      },
      modalView: false,
      flashcardDeckBeforeEditing: {},
      bottomScroll: true,
      topScroll: true,
      epubPrevDoubleChevronActive: false,
      epubNextDoubleChevronActive: false,
      newScrollTop: 0,
      highlights: undefined,
      showAnnotations: true,
      noteToView: undefined,
      freehandToView: undefined,
      hlPenSettings: {
        penColor: 1,
        hlColor: 1,
        lineThickness: 1
      },
      undoEnabled: false,
      redoEnabled: false,
      contextMenuListItemOpen: false,
      flashcardEditorSelectText: "",
      fromContextMenu: false,
      activePages: [],
      currentTime: moment().valueOf(),
      pageLoadTime: 0,
      location: 0,
      fullscreen: false,
      showSearchMode: false,
      search: "",
      searchResults: [],
      historySearchedResults: [],
      searchLoading: false,
      searchResultsPopup: false,
      searchIndex: -1,
      undoCalled: 0,
      redoCalled: 0,
      epubNextNavThrottled: _.debounce(this.epubNextPage, 500, {'leading': true, 'trailing': true}),
      epubPrevNavThrottled: _.debounce(this.epubPrevPage, 500, {'leading': true, 'trailing': true}),
      pdfPerPageNextNavThrottled: _.debounce(this.pdfPerPageNext, 500, {'leading': true, "trailing": true}),
      pdfPerPagePrevNavThrottled: _.debounce(this.pdfPerPagePrev, 500, {'leading': true, "trailing": true}),
      throttledPagesNext: 0,
      throttledPagesPrev: 0,
      loaded: false,
      editorToView: false,
      fontSize: null,
      fontColor: null,
      fontBackgroundColor: null,
      fontStyle: null,
      fontLineSpacing: null,
      fontLetterSpacing: null,
      textToSpeech: false,
      selectedText: '',
      voiceList: [],
      selectedVoice: 0,
      synth: window.speechSynthesis,
      greetingSpeech: new window.SpeechSynthesisUtterance(),
      textToSpeechPlaying: false,
      textToSpeechPaused: false,
      textToSpeechRate: 15,
      textToSpeechVolume: 3,
      TTSPlaying: false,
      TTSPaused: false,
      perPage: false,
      PDFPERPAGE: 100
    };
  },
  computed: {
    currentPageDisplay() {
      var display = bookUtils.pageDisplay(this.metadata, this.currentPageUsedForLabel);
      return display;
    }
  },
  destroyed: function() {
    _.each(this.unwatchFunctions, function(unwatchFunction) {
      unwatchFunction();
    });
  },
  mounted() {
    this.PDFPERPAGE = this.$config.get("pdfPerPage") || 100
    this.book = storeHelpers.getBookById(this, this.$route.params.id);
    setTimeout(() => {
      if (!this.book || (this.book.licenceExpiryDateTime && this.book.licenceExpiryDateTime < moment().unix())) {
        this.$router.push("/404");
        return;
      }  
    }, 200);    
    this.unwatchFunctions = utils.watchStorePropertiesWithCallback(this, ["resources", "attachments"], this.bookUpdated);
    
    this.getMetadata();
    if (document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement) {
      this.fullscreen = true;
    }
    document.addEventListener("fullscreenchange", this.exitFullscreen);
    document.addEventListener("mozfullscreenchange", this.exitFullscreen);
    document.addEventListener("MSFullscreenChange", this.exitFullscreen);
    document.addEventListener("webkitfullscreenchange", this.exitFullscreen);    
  },
  methods: {
    setTextToSpeechPlaying(val) {
      this.textToSpeechPlaying = val
      if (!val) {
        this.textToSpeechPaused = false
      }
    },
    stopSpeechSynth() {
      if (this.textToSpeechPlaying) {
        this.synth.cancel()
        this.textToSpeechPlaying = false
      }
    },
    pauseSpeechSynth() {
      if (this.textToSpeechPlaying) {
        this.synth.pause()
        // this.textToSpeechPlaying = false
        this.textToSpeechPaused = true
      }
    },
    resumeSpeechSynth() {
      if (this.textToSpeechPlaying) {
        this.synth.resume()
        // this.textToSpeechPlaying = true
        this.textToSpeechPaused = false
      }
    },
    stopSpeechSynthPDF() {
      var speech = window.speechSynthesis
      if (speech && speech.speaking == true)
        this.TTSPlaying = false
    },
    pauseSpeechSynthPDF() {
      var speech = window.speechSynthesis
      if (speech && speech.speaking == true)
        this.TTSPaused = true
    },
    resumeSpeechSynthPDF() {
      var speech = window.speechSynthesis
      if (speech && speech.paused == true)
        this.TTSPaused = false
    },
    setTTSPlaying(val) {
      this.TTSPlaying = val
      this.TTSPaused = false
    },
    setTTSPaused(val) {
      this.TTSPaused = val
    },
    toggleTextToSpeech() {
      this.textToSpeech = true
      this.hlPenMode = "textToSpeech"
      this.voiceList = window.speechSynthesis.getVoices()
    },
    setFontSize(size){
      this.fontSize = size
      var { documentHandle } = bookUtils.getiFrame();
      var all = documentHandle.getElementsByTagName("*")
      for (var i=0, max=all.length; i < max; i++) {
        if (all[i].style !== undefined)
          all[i].style.setProperty("font-size", size, "important")
      }
    },
    setFontColor(color){
      this.fontColor = color
      var { documentHandle } = bookUtils.getiFrame();
      var all = documentHandle.getElementsByTagName("*");
      for (var i=0, max=all.length; i < max; i++) {
        if (all[i].style !== undefined)
          all[i].style.setProperty("color", color, "important")
      }
    },
    setFontBackgroundColor(backgroundColor){
      this.fontBackgroundColor = backgroundColor
      var { documentHandle } = bookUtils.getiFrame();
      var all = documentHandle.getElementsByTagName("*");
      for (var i=0, max=all.length; i < max; i++) {
        if (all[i].style !== undefined)
          all[i].style.setProperty("background-color", backgroundColor, "important")
      }
    },
    setFontStyle(style){
      this.fontStyle = style
      var { documentHandle } = bookUtils.getiFrame();
      var all = documentHandle.getElementsByTagName("*");
      for (var i=0, max=all.length; i < max; i++) {
        if (all[i].style !== undefined) {
          if (style == "bold") all[i].style.setProperty("font-weight", style, "important")
          else all[i].style.setProperty("font-style", style, "important")
        }
      }
    },
    setFontLineSpacing(lineSpacing){
      this.fontLineSpacing = lineSpacing
      var { documentHandle } = bookUtils.getiFrame();
      var all = documentHandle.getElementsByTagName("*");
      for (var i=0, max=all.length; i < max; i++) {
        if (all[i].style !== undefined)
          all[i].style.setProperty("line-height", lineSpacing, "important")
      }
    },
    setFontLetterSpacing(letterSpacing){
      this.fontLetterSpacing = letterSpacing
      var { documentHandle } = bookUtils.getiFrame();
      var all = documentHandle.getElementsByTagName("*");
      for (var i=0, max=all.length; i < max; i++) {
        if (all[i].style !== undefined)
          all[i].style.setProperty("letter-spacing", letterSpacing, "important")
      }
    },
    bookUpdated: function() {
      var t = this;

      var attachmentsAndResources = storeHelpers.getAttachmentsAndResourcesForBook(t, t.book.id);
      t.resources = attachmentsAndResources.resources;
      t.attachments = attachmentsAndResources.attachments;

      t.drawings = storeHelpers.getDrawings(t.attachments, t.resources);
      t.highlights = _.keyBy(storeHelpers.getHighlightsForBook(t, t.book.id), "section");

      t.flashcardDecks = _.filter(t.resources, function(res) {
        return res.category === "flashcarddeck";
      });

      const flashcardAttachments = _.filter(t.attachments, function(att) {
        return (t.flashcardDecks.indexOf(_.find(t.flashcardDecks, function(flashcard) {
          return flashcard._id == att.resource;
        })) >= 0);
      });

      t.flashcardDeckAttachmentsByResourceId = _.groupBy(flashcardAttachments, "resource");

    },
    onPageLoading: function(loading) {
      this.pageLoading = loading;
    },
    findLastIndex: function(array) {
      let l = array.length;
      while (l--) {
          if (predicate(array[l], l, array))
              return l;
      }
      return -1;
    },
    getMetadata: async function() {
      var t = this;
      var url = t.$config.get("ecApi") + "web/books/epub/create/" + t.book._id;
      var response = await axios.get(url);
      this.metadata = response.data;

      // make page numbers consistent with pdf
      if (bookUtils.isMPUB(t.book)) {
        for (var i = 0; i < t.metadata.documents.length; i++) {
          if (!_.some(t.metadata.pages, page => page.file === t.metadata.documents[i])) {
            // get index of previous document in page array
            if (i > 0) {
              var index = _.findLastIndex(t.metadata.pages, page => page.file == t.metadata.documents[i-1])
              if (index != -1) {
                t.metadata.pages.splice(index+1, 0, {
                  "file": t.metadata.documents[i],
                  "generated": false,
                  "idref": t.metadata.documents[i],
                  "page": t.metadata.pages[index].page,
                  "selector": null,
                  "title": t.metadata.pages[index].title
                });
              }
            } else {
              t.metadata.pages.splice(0, 0, {
                "file": t.metadata.documents[i],
                "generated": false,
                "idref": t.metadata.documents[i],
                "page": 0,
                "selector": null,
                "title": "i"
              });
            }
          }
        }
        var count = 1;
        _.each(t.metadata.pages, function(page) {
          page.title = page.page;
          page.page = count++;
        });

        if (t.metadata.bookmarks[0].pageRange[0] < 1) {
          // update all page ranges with 1
          _.each(t.metadata.bookmarks, bookmark => {
            _.each(bookmark.pageRange, range => {
              range += 1
            })
          })
        }
      }
      
      if (!t.$route.params.currentPage) {
        this.$router.replace({
          name: "BookView",
          params: { currentPage: this.metadata.pages[0].title },
          query: this.$route.query
        });
      }

      var _currentPageOneBasedIndex = 1;
      var method = "default";

      if (t.$route.query.section) {
        _currentPageOneBasedIndex = bookUtils.getPageFromFile(t.metadata, t.$route.query.section, t.book.format);
        method = "redirect";
      } else if (t.$route.params.currentPage === "null") {
        // if last page accessed is set, load that page
        _currentPageOneBasedIndex = t.metadata.pages[0].page;
        method = "redirect";
      } else {
        _currentPageOneBasedIndex =
          _.findIndex(t.metadata.pages, function(page) {
            return page.title == t.$route.params.currentPage;
          }) + 1;
      }

      if (_currentPageOneBasedIndex === 0) {
        _currentPageOneBasedIndex = 1;
      }

      this.onCurrentPageChanged(_currentPageOneBasedIndex, method);

      // filter out all page documents with the documents array then add the leftovers to the pages
     
      t.loading = false;
      t.pageCount = t.metadata.pages.length;

      if (this.pageCount > this.PDFPERPAGE) {
        this.perPage = true
      }
    },
    toggleTOC() {
      this.tocOpen = !this.tocOpen;
    },
    penMode() {
      this.hlPenMode = "pen";
      this.undoCalled = 0;
      this.redoCalled = 0;
    },
    highlighterMode() {
      this.hlPenMode = "highlighter";
      this.undoCalled = 0;
      this.redoCalled = 0;
    },
    colorTextMode() {
      this.hlPenMode = "fontColor";
      this.undoCalled = 0;
      this.redoCalled = 0;
    },
    undo() {
      if (bookUtils.isMPUB(this.book)) {
        // epub
        if (this.undoEnabled)
          this.$refs.epubOrPdfBookView.undo();
      } else {
        // pdf
        this.undoCalled += 1;
      }
    },
    redo() {
      // if (this.redoEnabled) {
      //   this.$refs.epubOrPdfBookView.redo();
      // }
      if (bookUtils.isMPUB(this.book)) {
        // epub
      } else {
        // pdf
        this.redoCalled += 1;
      }
    },
    eyeMode() {
      this.showAnnotations = !this.showAnnotations;
    },
    flashcardEditor() {
      this.showFlashcardDeckList = !this.showFlashcardDeckList;
    },
    toggleSearchMode() {
      this.showSearchMode = !this.showSearchMode;
      this.showAnnotations = !this.showAnnotations;
      this.searchResultsPopup = !this.searchResultsPopup;
      
      if (!this.showSearchMode) {
        this.search = "";
        this.searchResults = [];
      }
    },
    toggleResources() {
      this.resourcePanelOpen = !this.resourcePanelOpen;
    },
    generateSummaryForPages() {
      if (this.activePages.length > 0) {
        this.$router.push("/book/" + this.book.id + "/pageRange/" + this.activePages[0].title + "/" + this.activePages[this.activePages.length - 1].title + "/summary");
      }
    },
    zoomIn() {
      if (bookUtils.isPDF(this.book)) {
        this.scaleZoom = Math.min(5, this.scaleZoom + 1)
        this.scale = Math.min(200, this.scale + 20);
      } else {
        this.scale = Math.min(400, this.scale + 10);
      }
      
    },
    zoomOut() {
      if (bookUtils.isPDF(this.book)) {
        this.scaleZoom = Math.max(-4, this.scaleZoom - 1)
        this.scale = Math.max(20, this.scale - 20)
      } else {
        this.scale = Math.max(30, this.scale - 10);
      }
    },
    onCurrentPageInput(e) {
      var t = this;
      var newInputValue = e.target.value;
      this.onCurrentPageChanged(bookUtils.pageOneBasedIndex(this.metadata, newInputValue), "input",  this.currentPage.method);
    },
    onCurrentScaleChanged(scale) {
      this.scale = Math.round(scale);
    },
    onCurrentPageChanged(oneBasedIndex, method) {
      if (!this.metadata) return;

      this.currentPage = {
        oneBasedIndex: parseInt(oneBasedIndex),
        method: method === "params" && this.currentPage ? this.currentPage.method : method
      };
      // storeHelpers.getBookById(this, this.book.id).lastAccessedPage = bookUtils.getCurrentPageObject(this.metadata, this.currentPage).title;

      this.onCurrentPageUsedForLabelChanged(oneBasedIndex);

      // epub
      storeHelpers.updateLastAccessPage(this, this.book.id, bookUtils.getCurrentPageObject(this.metadata, this.currentPage).title);
      if (bookUtils.isMPUB(this.book)) {
        var currentPageObject = bookUtils.getCurrentPageObject(this.metadata, this.currentPage);
        if (method !== "search" || this.$route.params.currentPage != this.currentPage.oneBasedIndex) {
          this.$router.replace({
            params: {
              currentPage: currentPageObject.title
            },
            query: this.$route.query
          });
        }

        // determine the active pages, pages on this HTML page
        this.activePages = _.filter(this.metadata.pages, function(page) {
          if (page && page.file == currentPageObject.file) {
            return page;
          }
        });

        // the first page should be at the top of the html page
        if (this.activePages.length > 0) {
          this.activePages[0].y = 0;
        }

      } 
      // pdf
      else {
        storeHelpers.updateLastAccessPage(this, this.book.id, bookUtils.getCurrentPageObject(this.metadata, this.currentPage).title);
        this.$router.replace({
          params: {
            currentPage: bookUtils.getCurrentPageObject(this.metadata, this.currentPage).title
          },
          query: this.$route.query
        });
        this.activePages = [{ title: this.currentPageDisplay }];
      }
      //pageOpenByMethod: function(handle, method, bookId, currentPage, pageLoadTime, selector, location) {
      analytics.pageOpenByMethod(this, method, this.book.id, this.currentPage.oneBasedIndex.toString(), this.pageLoadTime, this.selector, this.location);
    },
    onCurrentPageUsedForLabelChanged(oneBasedIndex) {
      this.currentPageUsedForLabel = parseInt(oneBasedIndex);
    },
    prevNav() {
      if (this.flashcardDeckEditor) {
        if (bookUtils.isPDF(this.book)) {
          var nextNavString = this.epubNextDoubleChevronActive ? "nextNavPage" : "nextNavSection";
          this.onCurrentPageChanged(Math.min(this.pageCount, this.currentPage.oneBasedIndex - 1), nextNavString);
        } else if (bookUtils.isMPUB(this.book)) {
          this.epubNextDoubleChevronActive = false;
          this.bottomScroll = true;
          var bodyAndWindowHandles = bookUtils.getiFrame();

          if (this.epubPrevDoubleChevronActive) {
            this.epubPrevDoubleChevronActive = false;
            var prevNavString = this.epubPrevDoubleChevronActive ? "prevNavPage" : "prevNavSection";
            this.onCurrentPageChanged(Math.max(0, this.currentPage.oneBasedIndex - 1), prevNavString);
            if (this.currentPage.oneBasedIndex === 1) {
              this.topScroll = false;
            }
          } else {
            var epubContainer = document.querySelector("#book-display");
            const newScrollTop = Math.floor(bodyAndWindowHandles.documentHandle.documentElement.scrollTop - epubContainer.clientHeight / 2);
            try {
              bodyAndWindowHandles.windowHandle.scrollTo({
                top: newScrollTop,
                left: 0,
                behavior: "smooth"
              });
            } catch (error) {
              bodyAndWindowHandles.windowHandle.scrollTop = newScrollTop;
            }
            if (newScrollTop < 0) {
              this.epubPrevDoubleChevronActive = true;
              if (this.currentPage.oneBasedIndex === 1) {
                this.topScroll = false;
              }
            }
          }
        }
      } else {
        
        if (bookUtils.isPDF(this.book)) {
          if (this.perPage == true) {
            this.throttledPagesPrev += 1
            this.onCurrentPageUsedForLabelChanged(Math.max(0, this.currentPage.oneBasedIndex - this.throttledPagesPrev));
            this.pdfPerPagePrevNavThrottled()
          } else {
            var prevNavString = this.epubPrevDoubleChevronActive ? "prevNavPage" : "prevNavSection";
            this.onCurrentPageChanged(Math.max(0, this.currentPage.oneBasedIndex - 1), prevNavString);
          }
        } else {
          this.throttledPagesPrev += 1;
          this.onCurrentPageUsedForLabelChanged(this.currentPage.oneBasedIndex - this.throttledPagesPrev);
          this.epubPrevNavThrottled()
        }
      }
    },
    epubPrevPage: function() {
      var prevNavString = this.epubPrevDoubleChevronActive ? "prevNavPage" : "prevNavSection";
      this.onCurrentPageChanged(Math.max(0, this.currentPage.oneBasedIndex - this.throttledPagesPrev), prevNavString);
      this.throttledPagesPrev = 0;
    },
    pdfPerPagePrev() {
      var prevNavString = this.epubPrevDoubleChevronActive ? "prevNavPage" : "prevNavSection";
      this.onCurrentPageChanged(Math.max(0, this.currentPage.oneBasedIndex - this.throttledPagesPrev), prevNavString);
      this.throttledPagesPrev = 0;
    },
    nextNav() {
      if (this.flashcardDeckEditor) {
        if (bookUtils.isPDF(this.book)) {
          var nextNavString = this.epubNextDoubleChevronActive ? "nextNavPage" : "nextNavSection";
          this.onCurrentPageChanged(Math.min(this.pageCount, this.currentPage.oneBasedIndex + 1), nextNavString);
        } else if (bookUtils.isMPUB(this.book)) {
          this.epubPrevDoubleChevronActive = false;
          this.topScroll = true;

          if (this.epubNextDoubleChevronActive) {
            this.epubNextDoubleChevronActive = false;
            var nextNavString = this.epubNextDoubleChevronActive ? "nextNavPage" : "nextNavSection";
            this.onCurrentPageChanged(Math.min(this.pageCount, this.currentPage.oneBasedIndex + 1), nextNavString);
            this.epubPrevDoubleChevronActive = true;
            if (this.currentPageDisplay === this.pageCount.toString()) {
              this.bottomScroll = false;
            }
          } else {
            var epubContainer = document.querySelector("#book-display");
            var bodyAndWindowHandles = bookUtils.getiFrame();
            const newScrollTop = bodyAndWindowHandles.documentHandle.documentElement.scrollTop + epubContainer.clientHeight / 2;
            try {
              bodyAndWindowHandles.windowHandle.scrollTo({
                top: newScrollTop,
                left: 0,
                behavior: "smooth"
              });
            } catch (error) {
              bodyAndWindowHandles.windowHandle.scrollTop = newScrollTop;
            }
            if (newScrollTop + epubContainer.clientHeight > bodyAndWindowHandles.documentHandle.documentElement.scrollHeight) {
              this.epubNextDoubleChevronActive = true;
              if (this.currentPageDisplay === this.pageCount.toString()) {
                this.bottomScroll = false;
              }
            }
          }          
        }
      } else {
        if (bookUtils.isPDF(this.book)) {
          if (this.perPage == true) {
            this.throttledPagesNext += 1;
            this.onCurrentPageUsedForLabelChanged(Math.min(this.pageCount, this.currentPage.oneBasedIndex + this.throttledPagesNext))
            this.pdfPerPageNextNavThrottled()
          } else {
            var nextNavString = this.epubNextDoubleChevronActive ? "nextNavPage" : "nextNavSection";
            this.onCurrentPageChanged(Math.min(this.pageCount, this.currentPage.oneBasedIndex + 1), nextNavString);
          }
          // this.topScroll = this.currentPage.oneBasedIndex === 1 ? false : true;
        } else {
          this.throttledPagesNext += 1;
          this.onCurrentPageUsedForLabelChanged(this.currentPage.oneBasedIndex + this.throttledPagesNext);
          this.epubNextNavThrottled()
        }
      }
    },
    epubNextPage: function() {
      var nextNavString = this.epubNextDoubleChevronActive ? "nextNavPage" : "nextNavSection";
      this.onCurrentPageChanged(Math.min(this.pageCount, this.currentPage.oneBasedIndex + this.throttledPagesNext), nextNavString);
      this.topScroll = this.currentPage.oneBasedIndex === 1 ? false : true;
      this.throttledPagesNext = 0;
    },
    pdfPerPageNext() {
      var nextNavString = this.epubNextDoubleChevronActive ? "nextNavPage" : "nextNavSection";
      this.onCurrentPageChanged(Math.min(this.pageCount, this.currentPage.oneBasedIndex + this.throttledPagesNext), nextNavString);
      this.throttledPagesNext = 0;
    },
    toggleContextMenu: function(val) {
      this.contextMenuOptions.bookId = this.book.id;
      this.contextMenuOptions.section = val.section;
    },
    openLocation: function(val) {
      this.onCurrentPageChanged(val, "location");
    },
    updatePrevChevron: function(val) {
      if (val) {
        if (this.currentPage.oneBasedIndex !== 1) {
          this.epubPrevDoubleChevronActive = true;
        } else {
          this.epubPrevDoubleChevronActive = false;
          this.topScroll = false;
        }
      } else {
        this.epubPrevDoubleChevronActive = false;
        this.topScroll = true;
      }
    },
    updateNextChevron: function(val) {
      var epubContainer = document.querySelector("#book-display");
      var bodyAndWindowHandles = bookUtils.getiFrame();
      if (val) {
        if (this.currentPageDisplay !== this.pageCount.toString()) {
          this.epubNextDoubleChevronActive = true;
        } else {
          if (this.newScrollTop + epubContainer.clientHeight > bodyAndWindowHandles.documentHandle.documentElement.scrollHeight) {
            this.epubNextDoubleChevronActive = false;
            this.bottomScroll = false;
          } else {
            this.epubNextDoubleChevronActive = false;
            this.bottomScroll = true;
          }
        }
      } else {
        this.epubNextDoubleChevronActive = false;
        this.bottomScroll = true;
      }
    },
    setFlashcardEditorSelectText: function(val) {
      this.flashcardEditorSelectText = val;
    },
    setHLPenColor: function(val) {
      var hlPenSettings = Object.assign({}, this.hlPenSettings);

      if (val.mode === "highlighter") {
        hlPenSettings.hlColor = val.colorIndex;
      } else {
        hlPenSettings.penColor = val.colorIndex;
      }

      this.hlPenSettings = hlPenSettings;
    },
    setHLPenThickness: function(val) {
      var hlPenSettings = Object.assign({}, this.hlPenSettings);
      hlPenSettings.lineThickness = val;
      this.hlPenSettings = hlPenSettings;
    },
    onBookError: function(msg) {
      // bookError: function(handle, bookId, errorString, errorType = 0)
      analytics.bookError(this, this.book.id, msg, 0);
      this.error = msg;
    },
    reload: function() {
      this.$router.go();
    },
    calculateLoadTime: function(epubLoadTime) {
      if (this.fontSize != null) {
        this.setFontSize(this.fontSize)
      }
      if (this.fontColor != null) {
        this.setFontColor(this.fontColor)
      }
      if (this.fontBackgroundColor != null) {
        this.setFontBackgroundColor(this.fontBackgroundColor)
      }
      if (this.fontStyle != null) {
        this.setFontStyle(this.fontStyle)
      }
      if (this.fontLineSpacing != null) {
        this.setFontLineSpacing(this.fontLineSpacing)
      }
      if (this.fontLetterSpacing != null) {
        this.setFontLetterSpacing(this.fontLetterSpacing)
      }
      this.pageLoadTime = epubLoadTime - this.currentTime;
    },
    fullscreenMode: function() {
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
          this.fullscreen = false;
        } else if (document.mozCancelFullScreen) {
          /* Firefox */
          document.mozCancelFullScreen();
          this.fullscreen = false;
        } else if (document.webkitExitFullscreen) {
          /* Chrome, Safari & Opera */
          document.webkitExitFullscreen();
          this.fullscreen = false;
        } else if (document.msExitFullscreen) {
          /* IE/Edge */
          document.msExitFullscreen();
          this.fullscreen = false;
        }
      } else {
        var elem = document.documentElement;
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
          this.fullscreen = true;
        } else if (elem.mozRequestFullScreen) {
          /* Firefox */
          elem.mozRequestFullScreen();
          this.fullscreen = true;
        } else if (elem.webkitRequestFullscreen) {
          /* Chrome, Safari & Opera */
          elem.webkitRequestFullscreen();
          this.fullscreen = true;
        } else if (elem.msRequestFullscreen) {
          /* IE/Edge */
          elem.msRequestFullscreen();
          this.fullscreen = true;
        }
      }
    },
    exitFullscreen: function(evt) {
      if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
        this.fullscreen = false;
      } else {
        this.fullscreen = true;
      }
    },
    onSearch: function(val) {
      this.search = val;
      this.searchResults = [];
      this.searchLoading = true;
    },
    setSearchIndex: function(index) {
      if (this.searchIndex !== index) {
        this.searchIndex = index;
      }
    },
    boldString: function(str, find) {
      var regEx = new RegExp(find, "ig");
      return str.replace(regEx, '<span style="color: #2368c5; font-size: 13pt">' + find + "</span>");
    },
    toggleSearchResults: function() {
      this.historySearchedResults = storeHelpers.getUserPreferences(this, "searchResults");
      // if (this.historySearchedResults && this.historySearchedResults[this.book.id]) {
      // document.getElementsByClassName("search-button")[0].click();
      document.querySelector('.search-button').click();
      this.searchResultsPopup != this.searchResultsPopup;
      // }
    },
    searchPopupOpen: function() {
      if (!this.searchResultsPopup) {
        // document.getElementsByClassName("search-button")[0].click();
        document.querySelector('.search-button').click();
        this.searchResultsPopup = true;
      }

    },
    saveSearchResults: function(searchResults) {
      var t = this;
      t.searchResults = searchResults;
      if (t.searchResults.length > 0 || t.search.length > 1) {
        var bookID = t.book.id;
        t.historySearchedResults = storeHelpers.getUserPreferences(t, "searchResults");

        if (!t.historySearchedResults) {
          t.historySearchedResults = {};
        }

        if (!t.historySearchedResults[bookID]) {
          t.historySearchedResults[bookID] = [];
        }

        var searchedResultsObject = {
          searchTerm: t.search,
          searchResults: t.searchResults.length
        };

        var newSearchTerm = _.find(t.historySearchedResults[bookID], history => {
          if (history.searchTerm === searchedResultsObject.searchTerm) {
            return true;
          }
        });

        if (!newSearchTerm) {
          t.historySearchedResults[bookID].push(searchedResultsObject);
        }
        storeHelpers.setUserPreferences(t, "searchResults", t.historySearchedResults);
      }
    },
    saveAnnotations() {
      this.saving = true
      this.$refs.epubOrPdfBookView.exportAnnotations()
      var t = this
      setTimeout(() => {
        t.savingSuccess = true
        setTimeout(() => {
          t.saving = false
          t.savingSuccess = false
        }, 500);
      }, 1000);
      
    }
  },
  beforeDestroyed() {
    document.removeEventListener("fullscreenchange", this.exitFullscreen);
    document.removeEventListener("mozfullscreenchange", this.exitFullscreen);
    document.removeEventListener("MSFullscreenChange", this.exitFullscreen);
    document.removeEventListener("webkitfullscreenchange", this.exitFullscreen);
    // storeHelpers.getBookById(this, this.book.id).lastAccessedPage = bookUtils.getCurrentPageObject(this.metadata, this.currentPage).title;
    // storeHelpers.updateLastAccessPage(this, this.book.id, bookUtils.getCurrentPageObject(this.metadata, this.currentPage).title);
  }
};
</script>

<style scoped lang="scss">
@import "src/css/vars.scss";

.help.is-danger {
  margin-top: 30px;
  text-align: center;

  .reload {
    margin-top: 30px;
    color: #666;
    cursor: pointer;
  }
}

.tools {
  display: block;
  position: fixed;
  width: 100%;
  .more-options {
    margin-left: 10px;
    margin-right: -10px;
  }

  .more-options .fal {
    padding: 0 10px;
  }
}

.book-view-container {
  text-align: center;
  width: 100vw;
  overflow: hidden;
  display: table;
 
  .toc-view,
  .book-view,
  .resources-view {
    display: table-cell;
  }

  .book-view {
    vertical-align: top;
    width: 100vw;
  }

  .toc-view,
  .resources-view {
    vertical-align: top;
    height: calc(100vh - 69px);
    background-color: $lightest-bg-color;
    padding-top: 10px;
    transition: 0.3s;
  }

  .resources-view {
    overflow: visible;
    z-index: 599;
    border-left: $border-color 1px solid;
    position: relative;
  }

  .toc-view {
    border-right: $border-color 1px solid;
    text-align: left;
    overflow-x: hidden;
  }

  .page-indicator input {
    text-align: center;
  }
}

.footer-wrapper {
  position: fixed;
  width: calc(100vw - 8px);
  bottom: 0;
  z-index: 599;

  .navigation-with-flashcard-editor {
    display: table;
    position: relative;
    padding: 0;
    border-top: 1px solid $background-color-darker3;
    width: calc(100vw - 8px);
    background: $background-color;
    z-index: -1;
    height: 51px;
    top: 15px;
  }

  .navigation {
    display: table;
    position: relative;
    padding: 0;
    border-top: 1px solid $background-color-darker3;
    width: calc(100vw - 8px);
    height: 51px;
    background: $background-color;
    z-index: 10;
  }

  .page-indicator {
    padding-top: 10px;
  }

  .tool {
    display: table-cell;
    width: 5%;
    // border: 1px solid fuchsia;

    .fal {
      font-size: 18pt;
    }

    .icon-button {
      padding: 10px 20px 0;
      margin-left: 0 !important;
    }
  }

  .page-indicator {
    width: 100%;
    text-align: center;
    vertical-align: top;

    input {
      width: 50px;
      font-size: 12pt;
    }
  }
}

.searched-content {
  overflow: scroll;
  overflow-x: hidden;
  height: 45vh;
  margin-right: -12px;
  margin-bottom: -11px;
  padding-right: 10px;
}

.search-mode {
  width: calc(100vw - 40px);
  .search-table {
    display: table;
    width: 100%;
    .search-row {
      display: table-row;
      .search-bar {
        display: table-cell;
        width: 92vw;
        // border: 1px solid black;
      }
      .search-close {
        display: table-cell;
        // border: 1px solid black;
      }
    }
  }
}

.search-header {
  height: 35px;
  width: 100%;
  position: -webkit-sticky;
  position: -moz-sticky;
  position: -ms-sticky;
  position: -o-sticky;
  position: sticky;
  top: 0px;
  background: $background-color;
  text-align: center;
  border-bottom: 1px solid #adadad;
  font-weight: bold;
}

.search-button {
  opacity: 0;
  position: absolute;
  left: 35px;
  top: 58px;
  margin-left: 10px;
}

.no-search-results {
  margin-left: calc(50% - 76px);
}

.search-results {
  display: table;
  width: 100%;
  .tr {
    display: table-row;
    .result {
      display: table-cell;
      padding: 10px 5px 10px 5px;
      text-align: left;
      border-bottom: 1px solid $border-color;
      // border: 1px solid $border-color;
      max-width: 250px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: pointer;
    }

    .on-page {
      display: table-cell;
      padding: 10px 10px 10px 5px;
      border-bottom: 1px solid $border-color;
      // border: 1px solid $border-color;
      font-weight: bold;
      text-align: right;
      color: $primary-color;
    }
  }
  .tr:hover {
    background-color: $button-on-hover-color;
    cursor: pointer;
  }
}

.ttsIcons {
  width: 28px !important;
  display: inline-block;
  margin-left: 20px;
}

.dropdownMenuNumber {
  height: 36px;
  font-size: 12pt;
}

.loadWrapper {
  position: fixed;
  top: 66px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 599;
}
</style>